import React, { useEffect, useState } from "react";
import { Button, Callout, Flex, Text } from "@appsmith/ads";
import { useDispatch, useSelector } from "react-redux";
import { PageContainer } from "global-styles/global.styles";
import { getUserDetails } from "selectors/UserSelectors";
import { fetchAccountDeletionPreflight } from "actions/AccountDeletionActions";
import { AppState } from "reducers";
import { DeleteAccountModal } from "./components/DeleteAccountModal";
import { withAuthentication, withEmailVerification } from "utils/RouterUtils";
import {
  createMessage,
  ACCOUNT_SETTINGS_TITLE,
  ACCOUNT_DELETE_HEADING,
  ACCOUNT_DELETE_DESCRIPTION,
  ACCOUNT_DELETE_BUTTON,
} from "constants/Messages";

function Account() {
  const dispatch = useDispatch();
  const user = useSelector(getUserDetails);
  const preflight = useSelector(
    (state: AppState) => state.accountDeletion.preflight.data,
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchAccountDeletionPreflight());
  }, [dispatch]);

  const hasActiveSubscription = preflight?.summary?.hasActiveSubscription;

  return (
    <PageContainer>
      <Flex flexDirection="column" gap="spaces-7">
        <Text kind="heading-l">{createMessage(ACCOUNT_SETTINGS_TITLE)}</Text>

        <Flex
          border="1px solid var(--ads-v2-color-border)"
          borderRadius="var(--ads-v2-border-radius)"
          flexDirection="column"
          gap="spaces-4"
          padding="spaces-6"
        >
          <Text kind="heading-s">Account details</Text>
          <Flex flexDirection="column" gap="spaces-2">
            <Text color="var(--ads-v2-color-fg-muted)" kind="body-s">
              Email
            </Text>
            <Text kind="body-m">{user?.email || ""}</Text>
          </Flex>
          {user?.name && (
            <Flex flexDirection="column" gap="spaces-2">
              <Text color="var(--ads-v2-color-fg-muted)" kind="body-s">
                Name
              </Text>
              <Text kind="body-m">{user.name}</Text>
            </Flex>
          )}
        </Flex>

        <Flex
          border="1px solid var(--ads-v2-color-fg-error)"
          borderRadius="var(--ads-v2-border-radius)"
          flexDirection="column"
          gap="spaces-4"
          padding="spaces-6"
        >
          <Text kind="heading-s">{createMessage(ACCOUNT_DELETE_HEADING)}</Text>
          <Text color="var(--ads-v2-color-fg-muted)" kind="body-m">
            {createMessage(ACCOUNT_DELETE_DESCRIPTION)}
          </Text>
          {hasActiveSubscription && (
            <Callout kind="warning">
              You have an active subscription. It will be canceled as part of
              the deletion process.
            </Callout>
          )}
          <Flex>
            <Button
              kind="error"
              onClick={() => setIsDeleteModalOpen(true)}
              size="md"
            >
              {createMessage(ACCOUNT_DELETE_BUTTON)}
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      />
    </PageContainer>
  );
}

export default withAuthentication(withEmailVerification(Account));
